/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const POST_URL = "/api/events";
export function post(model) {
    return apiService.post(POST_URL, false, {
        model
    });
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/events.ts